import { FC, useContext, useState } from "react";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";

interface AddLicensePanelProps {
  clientName: string;
  onAddLicense: (sfContractId: string) => void;
}

const AddLicensePanelContent: FC<AddLicensePanelProps> = (props: AddLicensePanelProps) => {
  const flyoutContext = useContext(FlyoutContext);
  const [sfContractId, setSfContractId] = useState("");

  const handleSFContractIdChange = (text: string) => {
    const numRegex = /(^\d+$|^$)/g;
    setSfContractId((prevValue) => numRegex.test(text) ? text : prevValue);
  }

  const handleAddClick = () => {
    props.onAddLicense(sfContractId);
    flyoutContext.handleCloseFlyout();
  }


  return (
    <>
      <QESTextInput
        containerClassName="col-8 p-0"
        label="SF Contract ID"
        testId="add-license-panel-content__sfContractId"
        value={sfContractId}
        onChange={(e) => handleSFContractIdChange(e.target.value)} />

      <FlyoutFooter
        submitButton={<QESButton
          qesTestId="add-license-panel-content__confirm"
          className="me-2"
          onClick={() => { handleAddClick(); }}
        >
          Add
        </QESButton>
        }
      />
    </>
  );
}

export default AddLicensePanelContent;
